import { useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { UpdateFromPipelineContext } from "./UpdateFromPipelineContext";
import actions from "../actions";
import { ImportListingDetailsModal } from "../../TransactionDetailsPage/Main/Details/ImportListingDetailsModal";

const TDIImportListingDetailsModal = ({ propertyTypes }) => {
  const { state, dispatch } = useContext(UpdateFromPipelineContext);

  const listing = state?.importModal?.listing;
  const listingUuid = listing?.uuid;
  const isModalOpen = state?.importModal?.isImportModalOpen;
  const updatedStatus = state?.importModal?.updatedStatus;
  const preStatus = listing?.status;

  const propertyDetails = useMemo(() => {
    if (!listing) return null;
    const details = listing.propertyDetails || {};
    return {
      id: listing.address?.id,
      street_address: listing.address?.streetAddress || "",
      city: listing.address?.city || "",
      state: listing.address?.locality || "",
      zip: listing.address?.postalCode || "",
      country: "US",
      neighborhood: listing.address?.neighborhood || "",
      county: listing.address?.county || "",
      beds: details.beds || "",
      baths: details.baths || "",
      sqft: details.sqft || "",
      year_built: details.year_built || "",
      parking: details.parking || "",
      foundation: details.foundation || "",
      property_type: listing.propertyType || { id: null, name: null },
    };
  }, [listing]);

  const listingDetailsData = useMemo(() => {
    if (!listing) return null;
    return {
      mls_number: listing.mlsNumber || "",
      price: listing.listingPrice || "",
      description: listing.description || "",
      source: listing.sourceId ? { id: listing.sourceId } : null,
    };
  }, [listing]);

  const accountPropertyTypes = useMemo(() => {
    if (!propertyTypes) return [];
    return propertyTypes.map((pt) => ({
      label: pt.name || pt.label,
      value: pt.id || pt.value,
    }));
  }, [propertyTypes]);

  const closeModal = () => {
    dispatch(actions.importModal.toggleImportModal(false, listing, updatedStatus));
  };

  const checkAddressAndcloseModal = () => {
    closeModal();
    if (!listing?.address?.streetAddress) {
      dispatch(actions.updateAddressModal.toggleUpdateAddressModal(true, updatedStatus, listing));
    }
  };

  const openUpdateTransactionModal = (isOpen, mlsListingData) => {
    dispatch(actions.updateTransactionModal.toggleUpdateTransactionModal(isOpen, listing, mlsListingData));
  };

  const revertStatus = (_uuid, status) => {
    dispatch(actions.listings.updateListing(listing, status));
    dispatch(actions.listings.setStatusLoading(listing.uuid, false));
  };

  const noop = () => {};

  return (
    <ImportListingDetailsModal
      modalOpen={isModalOpen}
      closeModal={closeModal}
      checkAddressAndcloseModal={checkAddressAndcloseModal}
      uuid={listingUuid}
      isFromIndex
      listingUuid={listingUuid}
      status={updatedStatus}
      preStatus={preStatus}
      propertyDetails={propertyDetails}
      listingDetailsData={listingDetailsData}
      accountPropertyTypes={accountPropertyTypes}
      photosAvailable={0}
      onGetAllDetailsAsThunk={noop}
      onGetPropertyTypesAsThunk={noop}
      closeModalAsThunk={noop}
      setToggleModal={noop}
      openUpdateTransactionModal={openUpdateTransactionModal}
      closeImportModal={closeModal}
      revertStatus={revertStatus}
    />
  );
};

TDIImportListingDetailsModal.propTypes = {
  propertyTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string,
    }),
  ),
};

TDIImportListingDetailsModal.defaultProps = {
  propertyTypes: [],
};

export default TDIImportListingDetailsModal;
